import { Box, Chip, Link as MuiLink, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ROUTES } from '@/utils/constants'
import type { UserStub } from '@/types/dashboard'
import type { WidgetProps } from './WidgetProps'
import { EmptyHint } from './EmptyHint'

interface TestRow {
  test_id: number
  lesson_id: number
  student: UserStub | null
  pending_answers: number
}

export function TestsToCheckWidget({ payload }: WidgetProps) {
  const { t } = useTranslation()
  const items = (payload.items ?? []) as TestRow[]
  const count = Number(payload.count ?? 0)

  if (count === 0) {
    return <EmptyHint fallbackKey="dashboard.widgets.tests_to_check.empty" />
  }

  return (
    <Stack spacing={0.75}>
      {items.map((item) => (
        <Box key={item.test_id} sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
          <MuiLink
            component={Link}
            to={ROUTES.TEST_RUN(item.test_id)}
            variant="body2"
            noWrap
            sx={{ flexGrow: 1, minWidth: 0 }}
          >
            {item.student?.name ?? `#${item.test_id}`}
          </MuiLink>
          <Chip
            size="small"
            color="warning"
            label={t('dashboard.widgets.tests_to_check.pendingAnswers', {
              count: item.pending_answers,
            })}
          />
        </Box>
      ))}
      {count > items.length && (
        <Typography variant="caption" color="text.secondary">
          +{count - items.length}
        </Typography>
      )}
    </Stack>
  )
}
